import { Component, OnChanges, Input, Output, EventEmitter, AfterViewInit, ElementRef, ViewChildren, QueryList, OnDestroy } from '@angular/core';
import { Event } from '@angular/router';

import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { CarouselStep, CarouselSlideMultipleSteps, ScreenSizeEnums, StepOtherOption } from '../carousel.interfaces';
import { ClaimingDialogActions } from '@app/api/models/claiming.models';

@Component({
  selector: 'csa-carousel-footer',
  templateUrl: './carousel-footer.component.html',
  styleUrls: ['./carousel-footer.component.scss'],
  standalone: false,
})
export class CarouselFooterComponent implements OnChanges, AfterViewInit, OnDestroy {
  @ViewChildren('circleBar') circlesList: QueryList<ElementRef>;
  @Output() startButtonClick: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() changeSlideClick: EventEmitter<number> = new EventEmitter<number>();
  @Output() arrowClick: EventEmitter<Event> = new EventEmitter<Event>();
  @Output() claimingDialogActionEmitter: EventEmitter<ClaimingDialogActions> = new EventEmitter<ClaimingDialogActions>();
  @Input() slides: CarouselStep[];
  @Input() slidesWithMultipleSteps: CarouselSlideMultipleSteps[];
  @Input() screenSize: ScreenSizeEnums;
  @Input() startButtonText: string;
  @Input() previousButtonText: string;
  @Input() nextButtonText: string;
  @Input() nextButton: string;
  @Input() stepSize: number;
  @Input() currentSlideIndex: number;
  @Input() showIndicators: boolean;
  @Input() otherOptions: StepOtherOption[];
  private readonly unsubscribe$: Subject<void> = new Subject<void>();
  steps: number[];
  screenSizeEnums = ScreenSizeEnums;
  indexBanner = 0;

  ngOnChanges(): void {
    const indicators = this.screenSize === ScreenSizeEnums.SmallScreen ? this.slides.length : this.slidesWithMultipleSteps.length;
    this.steps = Array(indicators)
      .fill(0)
      .map((value, key) => key);
    if (this.circlesList) {
      this.circlesList.notifyOnChanges();
    }
  }

  ngAfterViewInit(): void {
    if (this.circlesList) {
      this.circlesList.changes.pipe(takeUntil(this.unsubscribe$)).subscribe((circles: QueryList<ElementRef>) => {
        if (circles) {
          circles.forEach((circle, index) => this.updateCircleStylee(circle, index, this.currentSlideIndex));
        }
      });
    }
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  handleStartClick(): void {
    this.startButtonClick.emit(true);
  }

  handleNextClick(event: Event): void {
    if (this.currentSlideIndex < this.steps.length - 1) {
      this.changeSlideClick.emit(this.currentSlideIndex + 1);
      this.arrowClick.emit(event);
    }
    this.indexBanner++;
    this.changeBanner();
  }

  handlePreviousClick(event: Event): void {
    if (this.currentSlideIndex > 0) {
      this.changeSlideClick.emit(this.currentSlideIndex - 1);
      this.arrowClick.emit(event);
    }
    this.indexBanner--;
    this.changeBanner();
  }

  changeBanner() {
    const carouselCard = document.querySelectorAll('.carousel-card');
    if (carouselCard) {
      carouselCard.forEach(e => {
        e.classList.remove('select');
      });
      carouselCard[this.indexBanner].classList.add('select');
    }
  }

  handleOtherOptionClick(action: ClaimingDialogActions): void {
    this.claimingDialogActionEmitter.emit(action);
  }

  private updateCircleStylee(circle: ElementRef, index: number, value: number): void {
    index === value ? circle.nativeElement.classList.add('selected') : circle.nativeElement.classList.remove('selected');
  }
}
